<template>
    <div class="order-details">
        <ul class="top-radius">
            <li>
                <span>名称</span>
                <span>{{info.productName}}</span>
            </li>
            <li>
                <span>认购金额</span>
                <span>{{info.amount}}</span>
            </li>
            <li>
                <span>期限</span>
                <span>{{info.lockupPeriodStr}}</span>
            </li>
            <li>
                <span>债权预期收益率</span>
                <span>{{info.annuarate}}</span>
            </li>
            <li>
                <span>起息日</span>
                <span>{{info.sxbInterestBearingDate}}</span>
            </li>
            <li>
                <span>到期日</span>
                <span>{{info.calltime}}</span>
            </li>
        </ul>
        <ul class="mt8">
            <li>
                <span>交易单号</span>
                <span>{{dealNo}}</span>
            </li>
            <li>
                <span>交易状态</span>
                <span>{{info.statusStr}}</span>
            </li>
            <li>
                <span>创建时间</span>
                <span>{{info.createtime}}</span>
            </li>
        </ul>
        <ul class="mt8" v-if="2 < info.status && info.status < 5">
            <li>
                <span>回款银行账号</span>
                <span>{{info.bankInfo4Redeem}}<br v-if="info.bankInfo4Redeem"/><a href="javascript:void(0)"
                                                                                  v-if="info.status === 3"
                                                                                  @click="changeBankCard()">变更回款银行卡</a></span>
            </li>
        </ul>
        <div class="view-protocol" v-if="info.status === 0">
            <div class="smallBtn" @click="cancelOrder">取消订单</div>
            <div class="smallBtn gradualGold" @click="payment">立即支付</div>
        </div>
        <ul class="bottom-radius mt8" v-if="[3, 4, 5].includes(info.status)">
            <li @click="goInfo()">
                <span>债权列表</span>
                <span class="arrow"/>
            </li>
            <li @click="readFile(4)">
                <span>《风险提示确认函》</span>
                <span class="arrow"/>
            </li>
            <li @click="readFile(3)">
                <span>《合格购买者承诺书》</span>
                <span class="arrow"/>
            </li>
            <li @click="readFile(2)">
                <span>《债权转让协议》</span>
                <span class="arrow"/>
            </li>
            <li v-if="isChedai" @click="readFile(5)">
                <span>《{{xyTest}}》</span>
                <span class="arrow"/>
            </li>
        </ul>
    </div>

</template>

<script>
    import {bridgeRedirect, callHandler, downloadFile} from "../../../utils/bridge";

    export default {
        name: "jxlOrderDetails",
        data() {
            return {
                dealNo: "",
                isChedai: false,
                xyTest: '委托催收服务协议',
                info: {}
            };
        },
        created() {
            let params = this.$route.query;
            const {dealNo, token} = params;
            this.dealNo = dealNo;
            this.token = decodeURIComponent(token || "");
            // 根据dealNo判断是否是车贷
            let dealType = dealNo.substr(0,7);
            if(dealType === 'XHJIACD' || dealType === 'XHJIAAD' || dealType === 'XHJIABD' || dealType === 'XHJIASY'){
                this.isChedai = true;
                if(dealType === 'XHJIASY'){
                    this.xyTest = '委托管理服务协议';
                }
            }
            (async function () {
                const {data} = await this.$request({
                    url: "/h5/deal/jxlDetail.json",
                    data: this.$qs.stringify({
                        dealNo: this.dealNo,
                        token: this.token
                    })
                });
                this.info = data;
            }.bind(this))();
        },
        methods: {
            changeBankCard() {
                const {status, canModifyCardId} = this.info;
                if (status === 3) {
                    if(!canModifyCardId){
                        return this.$toast("紧急变更请联系您的专属顾问")
                    }
                    callHandler("xhModifyRedeemCard", {
                        dealNo: this.info.dealNo,
                        cardId: this.info.jiaCardId + ""
                    })
                }

            },
            readFile(type) {
                const url = location.origin + "/toumi-webapi/h5/protocol/jxl.json?" + this.$qs.stringify({
                    no: this.dealNo,
                    type,
                    token: this.token
                });
                downloadFile({
                    url: url,
                    isAes: "0", // 0：不加密。1：加密，
                    suffix: "pdf"
                });
            },
            cancelOrder: function() {
                let _self = this;
                let mask = this.$confirm({
                    title: "温馨提示",
                    closeAble: false,
                    content: "<p style='text-align: center;'>您确定取消订单吗？</p>",
                    ok() {
                        mask.close();
                        _self
                            .$request({
                                method: "post",
                                url: `/h5/deal/destroy.json`,
                                data: _self.$qs.stringify({
                                    dealNo: _self.dealNo,
                                    token: _self.token
                                })
                            })
                            .then(res => {
                                mask.close();
                                callHandler("xhCancelOrderSuc");
                            })
                            .catch(err => {
                                mask.close();
                                _self.$toast(err);
                            });
                    }
                }).show();
            },
            payment: function() {
                let url = `${location.origin}${location.pathname}#/assetDetails?productCode=${this.info.productCode}&contractSplit=${this.info.contractSplit}`;
                callHandler("xhPayOrderJXL", {
                    amount: this.info.amount,
                    dealNo: this.info.dealNo,
                    productId: this.info.productId,
                    productName: this.info.productName,
                    annualRate: this.info.annuarate,
                    urlCapital: url
                });
            },
            goInfo() {
                bridgeRedirect(`${location.origin}${location.pathname}#/creditorRight?token=${this.token}&dealNo=${this.dealNo}`);
            }
        }
    };
</script>

<style lang="less">
    .order-details {
        padding-bottom: 20px;

        .mt8 {
            margin-top: 8px;
        }

        ul {
            width: 100%;
            background: #fff;
            box-sizing: border-box;
            padding: 20px 16px;

            &.top-radius {
                border-top-right-radius: 24px;
                border-top-left-radius: 24px;
            }

            &.bottom-radius {
                border-bottom-right-radius: 24px;
                border-bottom-left-radius: 24px;
            }

            li {
                width: 100%;
                background: #fff;
                line-height: 20px;
                padding: 12px 0;
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
                font-size: 15px;
                position: relative;

                &:first-child {
                    padding-top: 0;
                }

                &:last-child {
                    padding-bottom: 0;
                }

                a {
                    color: #C0A266;
                }

                span {
                    &:first-child {
                        margin-right: 5px;
                        color: #aaaaaa;
                    }

                    &:last-child {
                        flex: 1;
                        font-size: 15px;
                        color: #333;
                        text-align: right;
                        word-wrap: break-word;
                        overflow: hidden;
                    }
                }

                &:after {
                    width: 100%;
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    display: block;
                    border-bottom: 0.5px solid #ebebeb;
                    content: " ";
                }

                &:last-child:after {
                    border: 0;
                }
            }

            .arrow {
                position: relative;
            }

            .arrow:after {
                content: "";
                display: inline-block;
                width: 10px;
                height: 10px;
                background: url("../../.././assets/images/normal/btn_arrow.png") no-repeat;
                background-size: 100% auto;
            }
        }

        .brt {
            border-radius: 20px 20px 0 0 !important;
            padding-bottom: 0 !important;

            li:last-child {
                padding-bottom: 12px;
            }
        }

        .brb {
            margin-top: 8px;
            padding-top: 0 !important;
            border-radius: 0 0 20px 20px !important;

            li:first-child {
                padding-top: 12px;
            }
        }
        .view-protocol {
            width: 100%;
            position: fixed;
            bottom: 0;
            left: 0;
            background: #ffffff;
            box-shadow: 0 0 8px 0 #eaeaea;
            border-radius: 24px 24px 0 0;
            padding: 16px 12px;
            display: flex;
            align-items: center;
            /*padding-right: 4px;*/
            box-sizing: border-box;
            justify-content: flex-end;
        }
        .order-adviser {
            font-size: 13px;
            color: #AAAAAA;
            padding: 12px 16px;
        }

        .smallBtn {
            background: #ffffff;
            width: 72px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            font-size: 13px;
            color: #c6c6c6;
            border: 0.5px solid #c6c6c6;
            margin-right: 12px;
            border-radius: 32px;
        }
        .gradualGold {
            background: linear-gradient(to bottom, #E0CB99 0%, #BD9C60 100%);
        }
        .sy {
            margin-top: 8px;
            padding-top: 0 !important;
            border-radius: 0 !important;
            padding-bottom: 12px !important;

            li:first-child {
                padding-top: 12px !important;
            }
        }


    }



</style>
